module.exports = __webpack_public_path__ + "img/ENG LOGO PNG.3f6e3fb8.png";